import { CKEditor } from "@ckeditor/ckeditor5-react";
import { default as CustomEditor } from "ckeditor5-custom-build/build/ckeditor";
import { useSelector } from "react-redux";

import "ckeditor5-custom-build/build/translations/tr";

const Editor = ({ value, onChange, disabled, className, inputProps }) => {
  const { settings } = useSelector((state) => state.app);

  return disabled ? (
    value ? (
      <div className="editor" dangerouslySetInnerHTML={{ __html: value }} />
    ) : (
      <input type="text" className={className} {...inputProps} disabled />
    )
  ) : (
    <CKEditor
      editor={CustomEditor}
      data={value}
      onChange={(_, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
      config={{
        removePlugins: ["Indent"],
        language: settings.language,
      }}
    />
  );
};

export default Editor;
